export default __webpack_public_path__ + "static/media/Home-northern.0d3a834e.png";